class MvAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mainTitle = document.querySelector(".s-mv__content");
    const decoGroup01 = document.querySelector(".s-mv__group-01");
    const decoGroup02 = document.querySelector(".s-mv__group-02");
    const decoGroup03 = document.querySelector(".s-mv__group-03");
    const decoration04 = document.querySelector(".s-mv__bg-04");
    const decoration05 = document.querySelector(".s-mv__bg-01");
    const decoration06 = document.querySelector(".s-mv__bg-06");
    const header = document.querySelector(".top-header");
    const humMenu = document.querySelector(".js-hum");

    setTimeout(() => {
      decoGroup01.classList.add("is-active");
      decoGroup02.classList.add("is-active");
      decoration04.classList.add("is-active");
    }, 800);
    
    setTimeout(() => {
      decoGroup03.classList.add("is-active");
      decoration05.classList.add("is-active");
      decoration06.classList.add("is-active");
    }, 1300);
    
    setTimeout(() => {
      mainTitle.classList.add("is-active");
      header.classList.add("is-active");
      humMenu.classList.add("is-active");
    }, 1700);
  }
}
